// extracted by mini-css-extract-plugin
export default {"wrapper":"gDq8w","content":"lO8FH","readonly":"MFjY4"};